import React, { useEffect, useContext } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { EmployeesProvider, EmployeesContext } from "../../store";
import EmployeesContent from "../../components/employees-content/employees-content.component";
import HeaderComponent from "../../components/header/header.component";
import LocationFilter from "src/components/location-filter/locationFilter.component";
import './employees.page.scoped.sass'
import { headerWithTableHeight } from "src/statics/header";

export default function EmployeesPage(props: any) {
  return (
    <EmployeesProvider>
      <EmployeesPageContent />
    </EmployeesProvider>
  );
}

export function EmployeesPageContent(props: any) {

  const { clearActiveFilters } = useContext(EmployeesContext);

  const commonService = new CommonService();

  const [t] = useTranslation();

  useEffect(() => {
    const title = t("employees_page_title");
    commonService.setTitle(title);
    clearActiveFilters();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <HeaderComponent title="employees_page_title" headerHeight={headerWithTableHeight} displayMenu={true}>
        <div className="filters-container">
          <LocationFilter />
        </div>
      </HeaderComponent>
      <EmployeesContent />
    </div>
  );
}
